/**
 * Created by john on 7/20/15.
 */

'use strict';

module.exports = {
    NAV: {
        'ACTIVE_GROUP_CHANGED': 'globalNav:activeGroupChanged',
        'ITEMS_ADDED': 'globalNav:itemsAdded',
        'ITEMS_REMOVED': 'globalNav:itemsRemoved',
        'TOGGLE_MENU': 'globalNav:toggleMenu',
        'TOGGLE_SEARCH': 'globalNav:toggleSearch',
        'NAVIGATED': 'globalNav:navigated',
        'RECEIVED_LIST_DATA': 'globalNav:receivedListData'
    },
    SEARCH: {
        'SEARCH_TERM_CHANGED': 'SEARCH_TERM_CHANGED',
        'SEARCH_RESULT_RETURNED': 'SEARCH_RESULT_RETURNED'
    },
    CART: {
        'cart:updated': 'cart:updated'
    },
    HAMBURGER: {
        'UPDATE_LOGIN': 'hamburgerMenu:updateLogin',
        'UPDATE_USER_INITIALS': 'hamburgerMenu:updateUserInitials',
        'UPDATE_USER_STATES': 'hamburgerMenu:updateUserStates'
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/nav/actions/ActionConstants.js
// module id = 35
// module chunks = 2 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55